import { convertDateToYYYYMMDDString } from "../../../../app/common";
import { LeaveEntity, LeaveMap } from "../../entriesAPI";
import { isAllowedContinuationOfType } from "../Shared/functions";

export const ABSENCE_HISTORY_LOOKBACK_DAYS = 180;

export const getAbsenceHistoryFromDate = (
  startDate: string,
  lookbackDays = ABSENCE_HISTORY_LOOKBACK_DAYS,
): string => {
  const fromDate = new Date(startDate);
  fromDate.setDate(fromDate.getDate() - lookbackDays);
  return convertDateToYYYYMMDDString(fromDate, "-");
};

export const getAbsenceWithContinuation = (
  responseData: LeaveMap,
  leaveEntity: LeaveEntity,
): LeaveEntity => {
  const contLeaveId = responseData.order.find(
    (key) =>
      key === leaveEntity?.continuationOf?.id &&
      isAllowedContinuationOfType(responseData.chains[key]?.[0].type),
  );

  const contLeave = contLeaveId ? responseData.chains[contLeaveId] : null;
  return {
    ...leaveEntity,
    previousLeaves: responseData,
    // If there are no previously set selected absence OR
    // If previously set selected absence is not found in new array,
    // set the first one from array as selected
    continuationOf:
      // TODO VK this is mess
      responseData.order.length > 0 && contLeave
        ? contLeave[0]
        : leaveEntity.continuationOf,
    continuationOfId: contLeaveId ? contLeaveId : null,
  };
};
